module.exports = __webpack_public_path__ + "static/media/zhiyezhuang4.eab97bd7.png";